import React, { useEffect } from 'react'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import MonthlyStatement from './monthly-statement'
import { useHistory, useLocation } from 'react-router-dom';
export default function CustomDatesStatement() {
    const location =useLocation();
    const history=useHistory();
    useEffect(()=>{
        if(location?.state===undefined){
            history.goBack()
        }
    },[])
    return (
        <div>
             <LayoutWithAccountCard breadCumKey='CUSTOM_DATES'>
            <MonthlyStatement customFromDate={location?.state?.customFromDate} customToDate={location?.state?.customToDate}/>
            </LayoutWithAccountCard>  
        </div>
    )
}
